import { render, staticRenderFns } from "./multipleInput.vue?vue&type=template&id=489cc44c&scoped=true&"
import script from "./multipleInput.vue?vue&type=script&lang=ts&"
export * from "./multipleInput.vue?vue&type=script&lang=ts&"
import style0 from "./multipleInput.vue?vue&type=style&index=0&id=489cc44c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cc44c",
  null
  
)

export default component.exports